import { render, staticRenderFns } from "./SurgDotsMenu.vue?vue&type=template&id=78b9477b&scoped=true&"
import script from "./SurgDotsMenu.vue?vue&type=script&lang=js&"
export * from "./SurgDotsMenu.vue?vue&type=script&lang=js&"
import style0 from "./SurgDotsMenu.vue?vue&type=style&index=0&id=78b9477b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b9477b",
  null
  
)

export default component.exports